import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    drawer: {
      width: 550,
    },
    item: { background: theme.white50 },

    header: {
      backgroundColor: theme.gray50,
      display: "flex",
      justifyContent: "space-between",
      "& > div": {
        display: "flex",
      },
    },
    subtitle: {
      color: theme.gray800,
      fontWeight: 500,
    },
    iconWrapper: {
      cursor: "pointer",
    },
    expandIcon: {
      cursor: "pointer",
      color: theme.gray500,
      width: 16,
      height: 16,
      margin: theme.spacing(8),
    },
    title: {
      fontWeight: 500,
      overflow: "hidden",
      textOverflow: "ellipsis",
      textWrap: "nowrap",
      borderLeft: `1px solid ${theme.gray200}`,
      padding: theme.spacing(6, 8),
    },
    closeIcon: {
      cursor: "pointer",
      margin: theme.spacing(6, 8),
      marginLeft: "auto",
    },
    content: {
      padding: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    detailsBox: {
      borderRadius: "8px",
      padding: theme.spacing(12),
      backgroundColor: theme.gray50,
      "& p": {
        fontSize: 14,
      },
    },
    saveButton: {
      marginLeft: theme.spacing(8),
    },
    btnContainer: {
      width: "100%",
      borderTop: `1px solid ${theme.gray100}`,
      display: "flex",
      justifyContent: "end",
      marginTop: "auto",
      padding: theme.spacing(6, 8),
      position: "sticky",
      bottom: 0,
      right: 0,
      backgroundColor: theme.white00,
      zIndex: 3,
    },
    detailsValue: {
      whiteSpace: "nowrap",
      display: "flex",
      justifyContent: "space-between",
    },
    copyInfo: {
      right: theme.spacing(8),
      background: `linear-gradient(90deg, rgba(255, 255, 255, 0), ${theme.gray50} 15.5%, ${theme.gray50})`,
    },
    avatar: {
      backgroundColor: theme.gray100,
      border: "1px solid rgba(229, 226, 241, 0.1)",
      borderRadius: "4px",
      color: theme.gray800,
      fontSize: "16px",
      fontWeight: 500,
      height: "48px",
      lineHeight: "19px",
      width: "49px",
    },
    mainDataContainer: {
      alignItems: "center",
      display: "flex",
      gap: theme.spacing(8),
      overflow: "hidden",
    },
    hiddenOverflow: {
      overflow: "hidden",
    },
    headerContainer: {
      alignItems: "start",
      display: "flex",
      gap: theme.spacing(4),
      height: "100%",
    },
    userHeader: {
      color: theme.gray800,
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    smallText: {
      color: theme.gray800,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "24px",
    },
    tierIcon: {
      color: theme.primary500,
      height: "16px",
      width: "16px",
    },
    divider: {
      borderBottom: `1px solid ${theme.gray200}`,
      width: "100%",
    },
    walletDetails: {
      padding: theme.spacing(4, 8),
    },
    walletName: {
      fontSize: 14,
      display: "flex",
      justifyContent: "space-between",
      "& > span": {
        color: theme.gray500,
      },
    },
    walletActivePoints: {
      alignItems: "baseline",
      display: "flex",
      fontSize: 18,
      fontWeight: 500,
      lineHeight: "29px",
      "& > span": {
        color: theme.gray500,
        fontSize: 14,
        fontWeight: 400,
        marginLeft: theme.spacing(5),
      },
    },
    tiersHeaderWrapper: {
      marginBottom: theme.spacing(8),
    },
    itemsContainer: {
      alignItems: "start",
      display: "flex",
      flexWrap: "nowrap",
      gap: theme.spacing(2),
      maxWidth: "100%",
    },
    clickable: {
      cursor: "pointer !important",
      "&:hover": {
        "& svg": {
          display: "block",
          width: "24px !important",
        },
      },
    },
    titleSection: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: theme.spacing(5, 0),
    },
    ellipsis: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  }),
);
